var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid-x latest-news"},[_vm._l((_vm.items),function(item,index){return [_vm._t("body",null,{"item":item})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }